import BlogCard, { BlogCardStyles } from "@hardware/Components/BlogCard";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import { connect } from "react-redux";

export const enum fields {
    blogLink = "blogLink",
    openNewWindow = "openNewWindow",
    showReadMore = "showReadMore",

    displayBlogLink = "Blog link",
    displayOpenNewWindow = "Should open in a new window?",
    displayShowReadMore = "Would you like to see more cta on each card?",
}

export interface OwnProps extends WidgetProps {
    fields: {
        [fields.blogLink]: LinkFieldValue;
        [fields.openNewWindow]: boolean;
        [fields.showReadMore]: boolean;
    };
}

export const mapStateToProps = (_: ApplicationState, __: OwnProps) => {
    return {};
};

export type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface BlogCardWidgetStyles {
    extendedStyle?: BlogCardStyles;
}

export const blogCardWidgetStyles: BlogCardWidgetStyles = {};

export const styles = blogCardWidgetStyles;

export const BlogCardWidget = ({ fields: { blogLink, openNewWindow, showReadMore } }: Props) => {
    return (
        <StyledWrapper>
            <BlogCard
                blogLink={blogLink}
                openNewWindow={openNewWindow}
                extendedStyles={styles.extendedStyle}
                showReadMore={showReadMore}
            ></BlogCard>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogCardWidget as any) as any,
    definition: {
        displayName: "Blog Card",
        group: "Verndale Box" as any,
        icon: "blog",
        fieldDefinitions: [
            {
                name: fields.blogLink,
                displayName: "Blog Link",
                editorTemplate: "CustomBlogLinkField" as any,
                defaultValue: {
                    value: "",
                } as any,
                fieldType: "General",
            },
            {
                name: fields.openNewWindow,
                displayName: "Open link in a new window",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.showReadMore,
                displayName: fields.displayShowReadMore,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
